import { render, staticRenderFns } from "./Pois.tpl?vue&type=template&id=7ad4d71d&"
import script from "./Pois.vue?vue&type=script&lang=ts&"
export * from "./Pois.vue?vue&type=script&lang=ts&"
import style0 from "./Pois.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports